import { SPLOOT_BADGE_COLOR } from "../themes";
import { PartnerPayoutStatus } from "../interfaces/wallet";

export const PAYOUT_ACTION_STATUS_BADGE_COLORS = {
  [PartnerPayoutStatus.REQUESTED]: SPLOOT_BADGE_COLOR.YELLOW,
  [PartnerPayoutStatus.CALCULATED]: SPLOOT_BADGE_COLOR.YELLOW,
  [PartnerPayoutStatus.APPROVED]: SPLOOT_BADGE_COLOR.GREEN,
  [PartnerPayoutStatus.REJECTED]: SPLOOT_BADGE_COLOR.RED,
  [PartnerPayoutStatus.PAID]: SPLOOT_BADGE_COLOR.BLUE,
  [PartnerPayoutStatus.CANCELLED]: SPLOOT_BADGE_COLOR.RED,
} as const;

